import { ProductCategory } from "..";

export interface ProductCategoryView extends ProductCategory  {
    ParentCategory?: string;
}
